import { SocialMediaService } from "./implementations/socialmedia.service";

export default defineNuxtPlugin((nuxtApp) => {
  const socialmedia = new SocialMediaService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgCmsApi,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
        socialmedia: socialmedia,
    },
  };
});